import heroBanner from "../../assets/img/discount_offers/hero-banner.webp";
import "./HeroSection.css";

export default function HeroSection({ onEntrepreneurClick, onYouthClick }) {
  return (
    <section className="hero-section position-relative overflow-hidden">

      {/* Background Image */}
      <img
        src={heroBanner}
        alt="Victory Day Banner"
        className="hero-bg-img"
      />

      {/* Content */}
      <div className="hero-content container">
        <div className="d-flex">

          {/* Only Button */}
          <button className="btn hero-offer-btn victory-border" onClick={onEntrepreneurClick}>
            উদ্যোক্তা
          </button>

          <button className="btn hero-offer-btn victory-border  ml-4" onClick={onYouthClick}>
            তারুণ্য
          </button>

        </div>
      </div>
    </section>
  );
}
